export default __webpack_public_path__ + "static/media/1288.7dc711bb.png";